import { defineComponent as _defineComponent } from 'vue'
import BasketSummaryLines from '@/ui/views/checkout/BasketSummaryLines.vue';
import { computed } from 'vue';

interface ICheckoutSummaryPOSProps {
    basket: IBasketViewModel,
    countryTaxTotal?: string | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutSummaryPOS',
  props: {
    basket: null,
    countryTaxTotal: { default: null }
  },
  setup(__props: any) {

const props = __props as { basket: IBasketViewModel, countryTaxTotal: string | null }



const hasTaxTotal = computed(() => !!props.basket.taxTotal);

return { __sfc: true,props, hasTaxTotal, BasketSummaryLines }
}

})